module.exports = __webpack_public_path__ + "img/img22.ef22fa3b.jpg";